export default __webpack_public_path__ + "static/media/reload.df60a89b.svg";